import React, { useState, useEffect } from 'react';
import { Input, Checkbox, Layout, Typography, Space, Card, Button, message } from 'antd';
import { UserOutlined, ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import AccessPolicyReadWriteForFields from './AccessPolicyReadWriteForFields'

const { Header, Content } = Layout;
const { Title } = Typography;
 
const AccessPolicyObjectSettings = ({ selectedAccessPolicy, onBack, objectSettingsData,accessPolicyData,onMain }) => {
    const [permissionSets, setPermissionSets] = useState([]);
    const [objects, setObjects] = useState([]);
    const [searchObject, setSearchObject] = useState('');
    const [selectedObjects, setSelectedObjects] = useState([]);
    const currentUserId = Cookies.get('userId');
    const [afterContinue, setAfterContinue] = useState(false);

    useEffect(() => {
        // Extract object names from objectSettingsData instead of fetching from API
        const fetchObjects=async()=>{   

            try{

                const apiService = new ApiService(
                    `${BASE_URL}/mt_objects`,
                    { 'Content-Type': 'application/json' },
                    'GET'
                );
                const response = await apiService.makeCall();
                if (Array.isArray(response)) {
                    setObjects(response.map(obj => obj.name));
                } else {
                    setObjects([]); // Set an empty array if response is not valid
                }

            }
            catch(error){
                console.log(error);
            }

        }
        fetchObjects();
    }, [objectSettingsData]);

    useEffect(() => {
        if (selectedAccessPolicy) {
            setPermissionSets(prev => [...new Set([...prev, selectedAccessPolicy])]);
        }
    }, [selectedAccessPolicy]);

    const handleSelectItem = (id) => {
        setSelectedObjects(prev => 
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const handleSelectAll = () => {
        setSelectedObjects(selectedObjects.length === objects.length ? [] : [...objects]);
    };

    const renderList = () => (
        <Card title="Objects" style={{ flex: 1 }}>
            <Input
                placeholder="Search Objects"
                value={searchObject}
                onChange={e => setSearchObject(e.target.value)}
                style={{ marginBottom: '8px' }}
            />
            <Checkbox
                onChange={handleSelectAll}
                checked={objects.length > 0 && selectedObjects.length === objects.length}
                indeterminate={selectedObjects.length > 0 && selectedObjects.length < objects.length}
            >
                Select All
            </Checkbox>
            <div style={{ maxHeight: '400px', overflowY: 'auto', marginTop: '8px' }}>
                {objects
                    .map(objName => (
                        <div
                            key={objName}
                            onClick={() => handleSelectItem(objName)}
                            style={{
                                padding: '8px',
                                background: selectedObjects.includes(objName) ? '#ffffcc' : 'transparent',
                                cursor: 'pointer',
                                borderBottom: '1px solid #f0f0f0'
                            }}
                        >
                            {objName}
                        </div>
                    ))}
            </div>
        </Card>
    );

    const handleContinue = () => {
        if (!selectedObjects) {
            message.warning('Please select at least one object');
            return;
        }
        setAfterContinue(true);
    };
 
    return (
        !afterContinue ? (
            <Layout style={{ height: '100vh', padding: '8px' }}>
                <Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff', marginBottom: '16px' }}>
                    <Space>
                        <UserOutlined style={{ fontSize: '24px' }} />
                        <Title level={3} style={{ margin: 0 }}>Manage Permission</Title>
                    </Space>
                    <Space>
                        <Button onClick={onBack}>
                            <ArrowLeftOutlined /> Back
                        </Button>
                        <Button type="primary" onClick={handleContinue}>
                            Continue <ArrowRightOutlined />
                        </Button>
                    </Space>
                </Header>
                <Content style={{ display: 'flex', gap: '16px' }}>
                    {renderList()}
                </Content>
            </Layout>
        ) : (
            <AccessPolicyReadWriteForFields 
            selectedAccessPolicy={selectedAccessPolicy}
            objectSettingsData={objectSettingsData}
            selectedObjects={selectedObjects}
            onBack={()=>setAfterContinue(false)}
            accessPolicyData={accessPolicyData}
            onMain={onMain}

             />
        )
    );
};

export default AccessPolicyObjectSettings;
